import type { FormTextEditorProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { TextEditor } from '@/components/TextEditor';

import { FormFieldShell } from '../FormFieldShell';

export const FormTextEditor = <TFieldValues extends FieldValues = FieldValues>(
  props: FormTextEditorProps<TFieldValues>,
) => {
  const { name, label, hint, description, isRequired, disabled } = props;

  return (
    <FormFieldShell
      name={name}
      description={description}
      render={({ field, fieldState, fieldId }) => (
        <TextEditor
          id={fieldId}
          value={field.value || ''}
          label={label}
          aria-label={label}
          isRequired={isRequired}
          hint={hint}
          disabled={disabled}
          aria-invalid={fieldState.invalid}
          onChange={field.onChange}
          onBlur={field.onChange}
        />
      )}
    />
  );
};
